import { render, staticRenderFns } from "./InfoLogic.vue?vue&type=template&id=0170eba0&scoped=true&"
import script from "./InfoLogic.vue?vue&type=script&lang=js&"
export * from "./InfoLogic.vue?vue&type=script&lang=js&"
import style0 from "./InfoLogic.vue?vue&type=style&index=0&id=0170eba0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0170eba0",
  null
  
)

export default component.exports